import React, { useState } from 'react';
import { BoxContainer, FormSection, TrGraphQLErrors } from '../../../components';
import { CustomInput } from 'reactstrap';
import { TrLoader, TrPlaceholder, RenderData, Td, Tr, Loader } from '@oforce/global-components';
import { Table } from '../../../components/table-2.0';

export default function BulkDownloadDocumentsDocsSelection({ formik, loading, error, clientId }) {
  const colSpan = 3;
  const initialToggleState = !!formik?.values?.documentIds.length;
  const [selectAll, setSelectAll] = useState(initialToggleState);
  const isClientContext = !!clientId;

  const { documentIdsFilteredByDate, documentsFilteredByDate, insuredIdsFilteredByDate, initialData } = formik?.values;

  const toggleSelectAll = selectAll => {
    if (!selectAll) {
      formik?.setFieldValue('documentIds', documentIdsFilteredByDate);
      formik?.setFieldValue('insuredIds', insuredIdsFilteredByDate);
    } else {
      formik?.setFieldValue('documentIds', []);
      formik?.setFieldValue('insuredIds', insuredIdsFilteredByDate);
    }
    setSelectAll(!selectAll);
  };

  const handleCheckChange = id => {
    let newIds;

    if (formik?.values?.documentIds?.includes(id)) {
      newIds = formik?.values?.documentIds.filter(documentId => documentId !== id);
    } else {
      newIds = [...formik?.values?.documentIds, id];
    }

    const insuredIds = initialData.filter(x => newIds?.includes(x.documentId))?.map(x => x.insuredId);
    formik?.setFieldValue('documentIds', newIds);
    formik?.setFieldValue('insuredIds', insuredIds);
    formik?.setFieldValue('insuredIdsFilteredByDocs', insuredIds);
  };

  if (loading) return <Loader />;

  return (
    <FormSection title="Select Documents">
      <BoxContainer>
        <Table responsive>
          <thead>
            <tr>
              <th>
                <CustomInput
                  id="toggleSelectAllDocumentIds"
                  type="checkbox"
                  checked={selectAll}
                  onChange={() => toggleSelectAll(selectAll)}
                  className="mb-1"
                />
              </th>
              <th>Document Name</th>
              <th>File Type</th>
            </tr>
          </thead>
          <tbody>
            <RenderData
              data={documentsFilteredByDate}
              loading={loading}
              error={error}
              loadingComponent={<TrLoader colSpan={colSpan} />}
              errorComponent={<TrGraphQLErrors colSpan={colSpan} error={error} />}
              placeholderComponent={<TrPlaceholder colSpan={colSpan}>No documents</TrPlaceholder>}
            >
              {documents =>
                documents?.map((document, i) => (
                  <Tr
                    key={i}
                    style={formik?.values?.documentIds?.includes(document?.id) ? { backgroundColor: '#e6eaf2' } : {}}
                  >
                    <Td>
                      <CustomInput
                        id={document?.name}
                        type="checkbox"
                        checked={formik?.values?.documentIds?.includes(document?.id)}
                        onChange={() => handleCheckChange(document?.id)}
                        className="mb-1"
                      />
                    </Td>
                    <Td>{document?.name}</Td>
                    <Td>
                      {isClientContext
                        ? document?.document?.filename?.split('.').pop().toUpperCase()
                        : document?.filename?.split('.').pop().toUpperCase()}
                    </Td>
                  </Tr>
                ))
              }
            </RenderData>
          </tbody>
        </Table>
      </BoxContainer>
    </FormSection>
  );
}
